;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.dashboard')
    .controller('DashboardEditModalController', DashboardEditModalController)

  DashboardEditModalController.$inject = [
    // Angular
    // Libs
    '$uibModalInstance',
    // Managers
    // Services
    // Const
    // Resolved
    'dashboard', 'prefs', 'isAdmin'
  ]

  function DashboardEditModalController (
    // Angular
    // Libs
    $uibModalInstance,
    // Managers
    // Services
    // Const
    // Resolved
    dashboard, prefs, isAdmin
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        ok: ok,
        cancel: cancel,
        dashboard: dashboard,
        isAdmin: isAdmin
      })

      init()
    }
    function init () {
      // self.dashboardDefault = _.get(prefs, 'settings.dashboard.default') === dashboard._id
    }

    function ok () {
      // if (self.dashboardDefault) {
      //   _.set(prefs, 'settings.dashboard.default', dashboard._id)
      // }
      prefs.save().then(function () {
        $uibModalInstance.close(dashboard)
      })
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }
  }
})(window.angular, window._)
